import {
  createComponentMapperModel,
  withCompInfo,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import { TinyMenuDefinition, TinyMenuProps } from '@wix/thunderbolt-components';
import { ITinyMenuStateValues } from '../TinyMenu.types';
import { Translations } from '../constants';

export const props = withCompInfo<
  TinyMenuProps,
  TinyMenuDefinition,
  TinyMenuProps
>()(
  [
    'fullNameCompType',
    'language',
    'compId',
    'pagesMap',
    'mainPageId',
    'translate',
    'trackClicksAnalytics',
  ],
  ({ translate, ...compPropsRest }, carmiData) => {
    return {
      ...carmiData,
      ...compPropsRest,
      translations: {
        ariaLabel:
          translate(
            Translations.ariaLabelNamespace,
            Translations.ariaLabelKey,
          ) || Translations.ariaLabelDefault,
      },
    };
  },
);

export const stateRefs = withStateRefsValues<keyof ITinyMenuStateValues>([
  'pageId',
  'reportBi',
]);

export default createComponentMapperModel({
  props,
  stateRefs,
});
